import { parseISO, differenceInYears } from 'date-fns';

export const calcIdade = (dataNascimento) => {
  if (dataNascimento === '' || dataNascimento === null) {
    return ''
  }
  // const dataNascimento = dados.data.data_nascimento;
  const idade = differenceInYears(new Date(), parseISO(dataNascimento));
  return ' - ' + idade + ' ANOS'
}